/**
 * 在节点表里找端口 —— **纯函数，归节点层**。
 *
 * ⚠️ 为什么从 `graph/linkRules.ts` 搬到这里：
 *
 * 资产校验（`node/package.ts`）也要用「这条边两头的端口是什么类型」，
 * 而 `node/` **不能** import `graph/`（依赖方向是 graph → node）。
 * 原来是反的：判定规则在 graph 层，节点层要用就只能**再抄一份**
 * —— 而两份「怎么找端口」迟早会不一致，那时候资产校验说的类型
 * 和编辑器认定的类型就是两回事了。
 */
import { repeaterIndexOf, repeaterInstanceSocket } from './rows'
import type { GraphNodeModel, SocketDef } from '../types/node'

/** 在给定节点表里找某个 handle 对应的端口定义（含变参实例与集合面） */
export function findSocketIn(
  models: readonly GraphNodeModel[],
  nodeId: string,
  handleId: string | null | undefined,
): SocketDef | undefined {
  if (!handleId) return undefined
  const model = models.find((m) => m.id === nodeId)
  if (!model) return undefined

  // 分组只是视图层的事，model.rows 始终是扁平的，所以这里能查到组内的端口
  for (const row of model.rows) {
    if (row.kind === 'input' || row.kind === 'output') {
      if (row.socket.id === handleId) return row.socket
      continue
    }
    if (row.kind === 'repeater') {
      const index = repeaterIndexOf(row, handleId)
      if (index >= 0) {
        /*
         * ⚠️ 用 `repeaterInstanceSocket` 而**不是**手搓一个：
         * 实例的类型是「按实例覆盖优先」（`instanceTypes[i]` 没连就回退
         * `socketType`）。手搓一份的话，组 / 循环那套「连上后确认成上游类型」
         * 就会在这里失效 —— 校验认的类型和画面上的类型不是一回事。
         */
        return repeaterInstanceSocket(row, index)
      }
    }
  }
  return undefined
}
